import * as React from 'react'
import * as styles from './setup.wizard.styl'
import * as View from '@src/components/common/view.page'
import { keys } from 'lodash'
import CircleTabs from '@src/components/common/circle.tabs'
import type { StepProps } from '@src/components/setup.steps'
import { RegisterSteps } from './сonfigurations'
import { useHistory } from 'react-router-dom'
import type { User } from '@src/redux/reducers/auth'
import type { UpdateUserResp } from '@src/endpoints/services/tenantMgr.service'
import uuidv4 from 'uuid/v4'
import { AppStorage } from '@src/utils/storage.helpers'
import { storagePrefix } from '@src/constants/constants'
import { useDispatch, useSelector } from 'react-redux'
import * as Selectors from './selectors'
import * as AuthActions from '@src/redux/actions/auth.actions'

const storage = new AppStorage(storagePrefix, sessionStorage)

interface Params {}
interface OwnProps {}
export type Props = OwnProps
interface State {
  currentStep: number
  completedSteps: number[]
}

const SetupWizard: React.FC<Props> = (props: Props) => {
  const history = useHistory<Params>()
  const user = useSelector(Selectors.getUser)
  const tenant = useSelector(Selectors.getTenant)
  const dispatch = useDispatch()

  const [state, setState] = React.useState<State>(() => {
    let currentStep = Number(storage.get('camSetupStep'))
    const completedStepsString = storage.get('camCompletedSteps')
    let completedSteps = [0, 0, 0, 0]
    if (currentStep === null || currentStep === 0) currentStep = 1
    if (completedStepsString !== null)
      completedSteps = completedStepsString.split('').map(d => Number(d))

    return {
      currentStep,
      completedSteps
    }
  })

  const countSteps = keys(RegisterSteps).length
  const step = RegisterSteps[state.currentStep]

  function updateUser(user: User, callback: (data?: UpdateUserResp) => void) {
    dispatch(
      AuthActions.updateUserDetails(
        { req_hdr: { tid: uuidv4() }, user },
        callback
      )
    )
  }

  function switchStep(step: number) {
    const completedSteps = [...state.completedSteps]
    completedSteps[state.currentStep] = 1

    setState(prev => ({
      ...prev,
      currentStep: step,
      completedSteps
    }))

    storage.set('camSetupStep', step.toString())
    storage.set('camCompletedSteps', completedSteps.join(''))
  }

  return (
    <View.ContentPage className={styles.content}>
      <div className={styles.pageTitle}>Setup</div>

      <CircleTabs
        tabs={RegisterSteps}
        currentTab={state.currentStep}
        completedSteps={state.completedSteps}
        switchStep={switchStep}
      />
      <div className={styles.steps}>
        {user && tenant ? (
          <div className={styles.wrapper}>
            <div className={styles.header}>
              <div className={styles.title}>{step.title}</div>
              <div className={styles.step}>
                {`Step ${state.currentStep} of ${countSteps}`}
              </div>
            </div>
            {React.createElement<StepProps>(step.component, {
              ...props,
              stepId: Number(state.currentStep),
              steps: RegisterSteps,
              switchStep,
              tenant: tenant || {},
              user: user || {},
              updateNotificationsAction: AuthActions.updateNotificationSettings,
              history,
              updateUser,
              footerComponent: step.footerComponent
            })}
          </div>
        ) : null}
      </div>
    </View.ContentPage>
  )
}

export default SetupWizard
